/* unplugin-vue-components disabled */import { render } from "./sh-files-empty.vue?vue&type=template&id=35380dbb&scoped=true"
import script from "./sh-files-empty.vue?vue&type=script&setup=true&lang=js"
export * from "./sh-files-empty.vue?vue&type=script&setup=true&lang=js"

import "./sh-files-empty.vue?vue&type=style&index=0&id=35380dbb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35380dbb"],['__file',"src/pages/sh-files/sh-files-empty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35380dbb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35380dbb', __exports__)) {
    api.reload('35380dbb', __exports__)
  }
  
  module.hot.accept("./sh-files-empty.vue?vue&type=template&id=35380dbb&scoped=true", () => {
    api.rerender('35380dbb', render)
  })

}


export default __exports__